import { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { BASE_URL } from "../apiConfig";
import { useLocation, useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  
  const navigate = useNavigate();

  
  const [user, setUser] = useState(() => {
    const cookie = Cookies.get("user");
    if (!cookie) return null;
    try {
      return JSON.parse(cookie);
    } catch (e) {
      return null;
    }
  });

  const [token, setToken] = useState(() => Cookies.get("WEB_STT") || null);

  const [role, setRole] = useState(() => {
    const cookie = Cookies.get("user");
    if (!cookie) return null;
    try {
      const u = JSON.parse(cookie);
      return u?.role ?? null;
    } catch (e) {
      return null;
    }
  });

  const [roles, setRoles] = useState(() => {
    const cookie = Cookies.get("user");
    if (!cookie) return {};
    try {
      const u = JSON.parse(cookie);
      if (u?.roles && Array.isArray(u.roles)) {
        return u.roles[0] || {};
      }
      return u?.roles || {};
    } catch (e) {
      return {};
    }
  });

  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    const currentToken = Cookies.get("WEB_STT");
    if (!currentToken) {
      logout();
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${BASE_URL}/api/auth/check-token`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${currentToken}`,
          Accept: "application/json",
        },
      });

      if (res.ok) {
        const data = await res.json();
        const userData = data?.data;
        if (userData) {
          const cookieOptions = { expires: 7 };
          Cookies.set("user", JSON.stringify(userData), cookieOptions);

          setUser(userData);
          setRole(userData.role);
          setRoles(userData.roles ? userData.roles[0] : null);
        }
      } else {
        logout();
      }
    } catch (err) {
      console.error("Auth check failed:", err);
    } finally {
      setLoading(false);
    }
  };


  const login = (userData, authToken, configData) => {
    const cookieOptions = { expires: 7 };
    Cookies.set("WEB_STT", authToken, cookieOptions);
    Cookies.set("user", JSON.stringify(userData), cookieOptions);
    Cookies.set("config", JSON.stringify(configData), cookieOptions);
    
    setUser(userData);
    setToken(authToken);
    setRole(userData.role);
    setRoles(userData.roles ? userData.roles[0] : null);
  };

  const logout = () => {
    navigate("/");
    Cookies.remove("WEB_STT");
    Cookies.remove("user");
    Cookies.remove("config");
    setUser(null);
    setToken(null);
    setRole(null);
    setRoles(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, role, roles, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
